<template>
  <div class="border border-radius border-box padding">
    <div class="font-size-large font-bold border-bottom padding-bottom padding-left">{{ $t('homePage.writingData.title') }}</div>
    <div class="grid">
      <div class="border-right">
        <div class="margin-bottom padding-left">{{ $t('homePage.writingData.todayCount') }}</div>
        <div class="font-bold font-size-large padding-left">{{ todayWritingCount }} {{ $t('homePage.writingData.characters') }}</div>
      </div>
      <div>
        <div class="margin-bottom padding-left">{{ $t('homePage.writingData.last7DaysCount') }}</div>
        <div class="font-bold font-size-large padding-left">{{ last7DaysWritingCount }} {{ $t('homePage.writingData.characters') }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  created() {
    this.$store.dispatch("writingDataModule/initialize");
  },
  computed: {
    todayWritingCount() {
      return this.$store.getters["writingDataModule/todayWritingCount"];
    },
    last7DaysWritingCount() {
      return this.$store.getters["writingDataModule/last7DaysWritingCount"];
    },
  },
});

interface Props {}

interface Data {}

interface Computed {
  todayWritingCount: number;
  last7DaysWritingCount: number;
}

interface Methods {}
</script>

<style lang="scss" scoped>
.border {
  border: 1px solid var(--color-border);
}

.border-radius {
  border-radius: var(--radius-sm);
}

.border-box {
  box-sizing: border-box;
  color: var(--color-text-normal);
}

.padding {
  padding: 10px;
}

.font-size-large {
  font-size: var(--font-size-md);
}

.font-bold {
  font-weight: var(--font-weight-bold);
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 20px;
  margin-top: 15px;
}

.border-right {
  border-right: 2px solid var(--color-border);
}

.border-bottom {
  border-bottom: 2px solid var(--color-border);
}

.padding-bottom {
  padding-bottom: 5px;
}

.padding-left {
  padding-left: 5px;
}

.margin-bottom {
  margin-bottom: 10px;
}
</style>
